export interface Image {
  url: string;
  alt: string;
  dimensions: { width: number; height: number };
}

export type ElementType =
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'heading4'
  | 'heading5'
  | 'heading6'
  | 'paragraph'
  | 'preformatted'
  | 'strong'
  | 'em'
  | 'list-item'
  | 'o-list-item'
  | 'group-list-item'
  | 'group-o-list-item'
  | 'image'
  | 'embed'
  | 'hyperlink'
  | 'label'
  | 'span';

export interface RichTextItem {
  type: ElementType;
  text: string;
  spans: Array<unknown>;
}

export enum SitewideOfferSliceTypes {
  OfferBanner = 'offer-banner',
  OfferBadge = 'offer-badge',
  OfferMessage = 'offer-message',
}

export type SitewideOfferSliceLabel =
  | 'product-page-offer-banner'
  | 'cart-page-offer-banner'
  | 'checkout-page-offer-banner'
  | 'checkout-confirmation-page-offer-banner'
  | 'brand-catalogue-page-offer-banner'
  | 'brand-page-offer-banner'
  | 'brand-tile-offer-badge'
  | 'product-tile-offer-badge'
  | 'brand-location-filter-offer-message';

export interface PrismicSitewideOfferPayloadSlice {
  slice_label: SitewideOfferSliceLabel;
  slice_type: string;
  primary: {
    heading?: RichTextItem[];
    body?: RichTextItem[];
    bypass_condition?: boolean;
    icon_key?: RichTextItem[];
    content?: RichTextItem[];
    message?: RichTextItem[];
  };
  items: unknown[];
}

export interface PrismicSlice<TPrimary, TItem> {
  slice_type: string;
  primary: TPrimary;
  items: TItem[];
}

export interface PrismicImage {
  dimensions?: { width: number; height: number };
  alt?: string | null;
  copyright?: string | null;
  url?: string;
  mobile?: {
    url?: string;
    alt?: string | null;
    dimensions: { width: number; height: number };
    copyright?: string | null;
  };
}

export interface PrismicEmbedVideo {
  author_name?: string | null;
  author_url?: string | null;
  embed_url?: string | null;
  height?: number | null;
  html?: string | null;
  provider_name?: string | null;
  provider_url?: string | null;
  thumbnail_height?: number | null;
  thumbnail_url?: string | null;
  thumbnail_width?: number | null;
  title?: string | null;
  type?: string | null;
  version?: string | null;
  width?: number | null;
}

export interface PrismicSitewideOfferPayload {
  'sitewide-offer': {
    [0]: {
      body: PrismicSitewideOfferPayloadSlice[];
    };
  };
}

export type LinkType = '_blank' | '_self' | '_parent' | '_top';

export interface PrismicLink {
  link_type: string;
  url?: string;
  key?: string;
  target?: LinkType;
}
